import React from 'react';

const ContentMessage = ({ message }) => {

  return (
    <div >
      {message}
    </div>
  );
};

export default ContentMessage;